"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolBar = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _Settings = _interopRequireDefault(require("@material-ui/icons/Settings"));
var _styles = require("./styles");
/** A ToolBar component. */
var ToolBar = function ToolBar(_ref) {
  var className = _ref.className,
    count = _ref.count,
    numSelected = _ref.numSelected,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement(_styles.Styled, {
    className: "".concat(className, " toolbar ").concat(numSelected > 0 ? 'highlight' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(className, " title")
  }, numSelected > 0 ? /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: className,
    color: "inherit",
    variant: "subtitle1"
  }, numSelected, ' ', "selected") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: className,
    variant: "body1",
    id: "tableTitle"
  }, title), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: "".concat(className, " caption"),
    variant: "caption",
    id: "tableCaption"
  }, "Currently viewing", ' ', count))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(className, " spacer")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: " ".concat(className, " actions")
  }, numSelected > 0 ? /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    title: "Delete"
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    "aria-label": "Delete"
  }, /*#__PURE__*/_react["default"].createElement(_Delete["default"], null))) : /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    title: "Toggle list"
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, null, /*#__PURE__*/_react["default"].createElement(_Settings["default"], null)))));
};
exports.ToolBar = ToolBar;